import CNLogo from "../../components/CNLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { allFooterLinks } from "../../components/Footer/links";
import { Dialog } from "@headlessui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { axiosNoAuth } from "../../config/axiosInstances";
import { PRIVATE_KEY } from "../../config/api_config";
import { requestNewCourse } from "../../redux/actions/userActivity";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import { IKImage } from "imagekitio-react";
import { getLeads } from "../../redux/actions/userSubscription";

const PricingFooter = () => {
  const [openModal, setOpenModal] = useState(false);
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const role_type = useSelector((store) => store?.useSubscription?.role_type);
  const email = useSelector((store) => store?.profileDetails?.email);
  const phone_number = useSelector(
    (store) => store?.profileDetails?.["phone-number"]
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("english");
  const [details, setDetails] = useState({
    user_name,
    email,
    phone_number,
    course: "",
    description: "",
  });

  return (
    <>
      <div className="mt py-4 md:py-0 bottom-0 w-full bg-midnight text-center text-white">
        <div className="mx-3  mb-6 flex items-center justify-center gap-2 text-xs md:hidden">
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.termsConditions}
            className="md:justify-start"
          >
            Terms and Conditions
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.privacyPolicy}
            className=""
          >
            Privacy Policy
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={allFooterLinks.aboutUs}
            className=""
          >
            About Us
          </a>
        </div>

        <div className="text-xs md:flex md:cursor-pointer md:items-center md:justify-between md:p-6 md:text-sm">
          <div className="ml-4 flex justify-center gap-8 md:hidden">
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.youtube}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon
                className="md:transform md:hover:translate-y-2"
                size="xl"
                icon={faYoutube}
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.facebook}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faFacebook} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.instagram}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faInstagram} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.linkedin}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faLinkedin} />
            </a>
          </div>

          <div className="mt-4 ml-4 flex items-center justify-center gap-3 md:hidden">
            <div className="text-white md:mr-6" >
              <a href="mailto:hello@careerninja.in">
                  <FontAwesomeIcon size="xl" icon={faEnvelope} />
                <span className="font-bold text-white">
                  {" "}
                  hello@careerninja.in
                </span>
              </a>
            </div>
            <a
              href={`https://api.whatsapp.com/send?phone=919160950649&text=I%20am%20interested%20in%20LearnTube`}
              target="_blank"
              rel="noreferrer"
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faWhatsapp} />
              <span className="text-white "> +91 9160950649</span>
            </a>
          </div>

          <p className="mt-5 text-supertiny md:hidden">© 2026 CareerNinja</p>

          <div className="mt-3 flex-col cursor-pointer" onClick={() => navigate('/courses')}>
          <div className='w-fit flex items-center mx-auto rounded-md gap-2' onClick={()=> navigate('/courses')}>
                                <img alt="a green and blue play button on a black background" src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager"   className='w-[35px] h-[35px] md:w-[42px] md:h-[42px]'/>
                                <p className='text-lg md:text-xl font-medium text-white'>LearnTube.ai</p>
                            </div>
            <p className="hidden text-supertiny md:block md:text-xs mt-1">
              © 2026 CareerNinja
            </p>
          </div>
          <div className="hidden md:flex">
            <div className="text-white md:mr-6">
              <a href="mailto:hello@careerninja.in">
                    <FontAwesomeIcon size="xl" icon={faEnvelope} />
                  <span className="font-bold text-white">
                    {" "}
                    hello@careerninja.in
                  </span>
              </a>
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={
                "https://api.whatsapp.com/send?phone=919160950649&text=I%20am%20interested%20in%20LearnTube"
              }
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faWhatsapp} />
              <span className="font-bold text-white"> +91 9160950649</span>
            </a>
          </div>
          <div className="hidden justify-center md:flex">
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.youtube}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faYoutube} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.facebook}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faFacebook} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.instagram}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faInstagram} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={allFooterLinks.linkedin}
              className="text-white md:mr-6"
            >
              <FontAwesomeIcon size="xl" icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingFooter;
